export const isPromoActive = (promo) => {
  if (!promo || !promo.enabled) return false;
  const now = Date.now();
  if (promo.startDate) {
    const s = new Date(promo.startDate).getTime();
    if (!isNaN(s) && now < s) return false;
  }
  if (promo.endDate) {
    const e = new Date(promo.endDate).getTime();
    if (!isNaN(e) && now > e) return false;
  }
  return true;
};

export const promoKey = (promo) => `ntoa_promo_seen_${promo?.startDate || ""}_${promo?.endDate || ""}`;
